const emailLeakMapper = {
    toDomain(data) {
        return {
            id: data.id,
            name: data.name,
            title: data.title,
            description: data.description,
            logoPath: data.logoPath,
            compromisedData: data.compromisedData
        }
    }
};

export {
    emailLeakMapper
};
